import { useGetSellersQuery } from 'services/api';
import styled from 'styled-components';
import { ContainedFormReactSelect } from '../../../Form/FinalForm/Contained/ContainedFormReactSelect';
import { AUCTION_TYPES } from 'constants';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 60px;
  div:first-child {
    flex: 1 1 80%;
  }
`;

export const auctionTypeOptions = [
  {
    label: 'Autoaxess',
    value: AUCTION_TYPES.AUTOAXESS
  },
  {
    label: 'Second Chance',
    value: AUCTION_TYPES.SECOND_CHANCE
  },
  {
    label: 'Frontline',
    value: AUCTION_TYPES.FRONTLINE
  }
];

export const AuctionField = () => {
  return (
    <Wrapper>
      <ContainedFormReactSelect label="Auction" name="auction_type" options={auctionTypeOptions} />
    </Wrapper>
  );
};
